var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategories = function SvgCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 19 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 9 9 0l5.5 9zm11 11q-1.875 0-3.188-1.312Q10 17.375 10 15.5t1.312-3.188Q12.625 11 14.5 11t3.188 1.312Q19 13.625 19 15.5t-1.312 3.188T14.5 20M0 19.5v-8h8v8zM14.5 18q1.05 0 1.775-.725T17 15.5t-.725-1.775T14.5 13t-1.775.725T12 15.5t.725 1.775T14.5 18M2 17.5h4v-4H2zM7.05 7h3.9L9 3.85z"
  })));
};
export default SvgCategories;